export default __webpack_public_path__ + "static/media/PropertyDev_BG-01.50883d2d.png";